import dayjs from 'dayjs';
import { normalizeProvince, strTitlelize } from 'src/helpers';
import { CTAsContactoTurismos } from 'src/feature-app/InputsValues';
import { franjaHoraria } from 'src/feature-app/InputsValues';
import {
	isGooglePlace,
	weekDay_DayNumber_Month,
	weekDay_DayNumber_Month_Hour,
} from 'src/feature-app';
import { CTAsMotivos } from 'src/forms';

//FUNCIONES GESTIÓN OUTPUTS

// cambio value por label
export const changeValueForLabel = (ctas: any, fields: any, field: string) => {
	const result = ctas.find((option: any) => option.value === fields[field]);
	return result ? result.label : fields[field];
};

// formacion frase slot de cita
const getOutputSlotFrom = (fields: any) => {
	const CTAsMotivo = CTAsMotivos(true); // Forzamos isComerciales para tenes todos los CTAs
	const selectedMotivo = CTAsMotivo.find(CTA => CTA.value === fields.motivo);

	if (fields.dealer.dmsInfo && fields.dealer.dmsInfo.dmsAvailable) {
		const momentSlot = weekDay_DayNumber_Month_Hour(fields.slot.from);
		const formatedSlot =
			momentSlot.split(',')[0] +
			' de ' +
			momentSlot.split(',')[1].charAt(0).toLowerCase() +
			momentSlot.split(',')[1].slice(1);
		return selectedMotivo
			? `${selectedMotivo.detallesPrevStep} el ${formatedSlot
					.replace('-', ' a las ')
					.concat('h')}`
			: `El ${formatedSlot.replace(',', ' de ').concat('h')}`;
	} else {
		const momentSlot = weekDay_DayNumber_Month(fields.slot.from);
		const formatedSlot =
			momentSlot.split(',')[0] +
			' de ' +
			momentSlot.split(',')[1].charAt(0).toLowerCase() +
			momentSlot.split(',')[1].slice(1);

		const horarioTranslate = franjaHoraria.find(
			(h: any) => h.code === fields.slot.dayMoment.code,
		);
		return selectedMotivo
			? `${selectedMotivo.detallesPrevStep} el ${formatedSlot.concat(
					horarioTranslate.name,
			  )}`
			: `El ${formatedSlot.concat(horarioTranslate.name)}`;
	}
};

// output localización
const getLocationOutput = (formInfo: any, dealersInfo: any) => {
	if (
		formInfo.userSuggestion?.name &&
		formInfo.userSuggestion?.markerInfo?.dealerInfo?.address
	) {
		return `${formInfo.userSuggestion.name} en ${formInfo.userSuggestion.markerInfo.dealerInfo.address}`;
	} else if (
		formInfo.userSuggestion?.VGED_CommercialName__c &&
		formInfo.userSuggestion?.Province
	) {
		return `${strTitlelize(
			formInfo.userSuggestion.VGED_CommercialName__c,
		)} en ${strTitlelize(formInfo.userSuggestion.Province)}`;
	} else if (
		formInfo.userSuggestion?.TXT_V_Installation_Data_Name__c &&
		formInfo.userSuggestion?.TXT_V_Address__c
	) {
		return `${strTitlelize(
			formInfo.userSuggestion.TXT_V_Installation_Data_Name__c,
		)} en ${strTitlelize(formInfo.userSuggestion.TXT_V_Address__c)}`;
	} else if (
		dealersInfo.selectedInstallation?.VGED_CommercialName__c &&
		dealersInfo.selectedInstallation?.Province
	) {
		return `${strTitlelize(
			dealersInfo.selectedInstallation.VGED_CommercialName__c,
		)} en ${strTitlelize(
			normalizeProvince(dealersInfo.selectedInstallation.Province),
		)}`;
	} else if (
		dealersInfo.selectedDealer?.name &&
		dealersInfo.selectedDealer?.markerInfo?.dealerInfo?.province
	) {
		return `${strTitlelize(
			dealersInfo.selectedDealer.name,
		)} en ${strTitlelize(
			normalizeProvince(
				dealersInfo.selectedDealer.markerInfo.dealerInfo.province,
			),
		)}`;
	} else if (
		formInfo.userSuggestion?.name &&
		isGooglePlace(formInfo.userSuggestion)
	) {
		return formInfo.userSuggestion.name;
	} else {
		return;
	}
};

const getUnknowOutput = (fields: any[], field: string) => {
	if (fields[field] == 'true') {
		return 'Sí';
	}
	if (fields[field] == 'false') {
		return 'No';
	}
	if (dayjs(fields[field], 'YYYY-MM-DD').isValid()) {
		return dayjs(fields[field], 'YYYY-MM-DD').format('DD/MM/YYYY');
	}
	if (typeof fields[field] == 'string') {
		return fields[field].replace(/,+/g, ', ');
	}

	return fields[field];
};

// SWITCH CASE PARA DETERMINAR EL OUTPUT DEL PREVIOUS STEP

export const getUpdatedField = (
	field: string,
	formData: any,
	dealersInfo: any,
	formInfo: any,
	previousStep?: any,
) => {
	const { fields } = formData;
	const { formName } = fields;
	const { selectedInstallation } = dealersInfo;

	if (previousStep?.ctas) {
		return changeValueForLabel(previousStep.ctas, fields, field);
	}

	const CTAsMotivo = CTAsMotivos(true); // Forzamos isComerciales para tenes todos los CTAs

	switch (field) {
		case 'motivo':
			return changeValueForLabel(CTAsMotivo, fields, field);
		case 'contacto':
			return changeValueForLabel(CTAsContactoTurismos, fields, field);
		case 'slot.from':
			return getOutputSlotFrom(fields);
		case 'dealer.name':
			return fields.dealer.name;
		case 'installation':
		case 'location':
			return getLocationOutput(formInfo, dealersInfo);
		case 'kilometros':
			if (fields.kilometros == 0) {
				return 'No estoy seguro';
			} else {
				return `${fields.kilometros[0]}km - ${fields.kilometros[1]}km`;
			}
		case 'cellphone':
			return `${fields.prefix} ${fields[field]}`;
		default:
			return getUnknowOutput(fields, field);
	}
};
